import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()(theme => ({
  chip: {
    maxWidth: '100%',
  },
  ellipsisChip: {
    overflow: 'hidden',
  },
  checkboxRow: {
    '&:hover': {
      backgroundColor: theme.palette.primaryBackground.main,
    }
  },
  primaryBackground: {
    background: 'linear-gradient(0deg, rgba(72, 117, 117, 0.08), rgba(72, 117, 117, 0.08))'
  },
}));
